import { Content, TextWrap } from '@/components/organisms/mediaSelect/MediaSelect.styled';
import {
  ButtonWrap,
  MediaLogo,
  MediaWrap,
  SubTitleWrap,
  Wrapper,
  Image,
} from '@/components/organisms/animateModal/AnimateModal.styled';
import { CloseWrap } from '@/components/common/modal/DefaultModal.styled';
import { Button, Subtitle8, Title1, Title4 } from '@/components/atoms';
import { TELECOM } from '@/const';
import { useCallback, useState } from 'react';
import { useRouter } from 'next/router';

const AnimatedModal = () => {
  let telecomList = [...TELECOM];
  const router = useRouter();
  const [showFull, setShowFull] = useState(false);
  const [activeTelecom, setActiveTelecom] = useState<string>('');

  const handleClickMedia = (telecom: string) => {
    router.prefetch(`/${telecom}/collection`).catch((err) => console.log(err));
    setActiveTelecom(telecom);
    setShowFull(true);
  };
  const handleClickClose = () => {
    setShowFull(false);
  };

  const handleClickButton = useCallback(async () => {
    await router.push(`/${activeTelecom}/collection`);
  }, [activeTelecom, router]);

  return (
    <Wrapper showFull={showFull}>
      {showFull ? (
        <CloseWrap>
          <Image src="/close.svg" alt="close" onClick={handleClickClose} loading="lazy" />
        </CloseWrap>
      ) : (
        <></>
      )}
      <Content>
        {showFull ? (
          <TextWrap>
            <Title1>이용 중이신 통신사를 선택해 주세요.</Title1>
            <Title4 color="gray-40">정확한 통신사를 선택해야 혜택을 받을 수 있어요.</Title4>
          </TextWrap>
        ) : (
          <></>
        )}
        <MediaWrap>
          {telecomList.map((telecom: string) => (
            <MediaLogo
              isActive={telecom === activeTelecom}
              showFull={showFull}
              key={telecom}
              onClick={() => handleClickMedia(telecom)}
            >
              <Image src={`/logo_${telecom}.svg`} alt={telecom} loading="lazy" />
            </MediaLogo>
          ))}
        </MediaWrap>
        {showFull && activeTelecom === 'skt' ? (
          <SubTitleWrap>
            <Subtitle8 color="gray-50">SKT 알뜰폰 사용자는 혜택 수신에 제한이 있습니다.</Subtitle8>
          </SubTitleWrap>
        ) : (
          <></>
        )}
        <ButtonWrap showFull={showFull}>
          <Button full size="lg" disabled={!showFull} onClick={handleClickButton}>
            {showFull ? '확인' : '통신사를 선택해 주세요'}
          </Button>
        </ButtonWrap>
      </Content>
    </Wrapper>
  );
};

export default AnimatedModal;
